import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-gray-500 text-sm font-semibold tracking-wider uppercase mb-3">
            About Us
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6 font-['Playfair_Display']">
            Welcome to Church of Pentecost UK Mansfield
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We are a vibrant, multicultural Christian community in Mansfield, dedicated to spreading the Gospel 
            and serving our community with love and compassion. Our church is a place where people from all 
            backgrounds come together to worship, grow in faith, and support one another.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-3xl font-bold text-black mb-6 font-['Playfair_Display']">
              Our Mission
            </h3>
            <p className="text-gray-600 leading-relaxed mb-6">
              Church of Pentecost UK Mansfield is committed to fulfilling the Great Commission by reaching out 
              to the lost, nurturing believers, and equipping them for service. We believe in the power of prayer, 
              the authority of Scripture, and the transforming work of the Holy Spirit.
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              Our church provides a welcoming environment where individuals and families can experience God's love, 
              develop meaningful relationships, and discover their purpose in Christ. We are passionate about making 
              disciples and impacting our community in Mansfield and beyond.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-gray-500 text-sm font-semibold tracking-wider uppercase mb-4">
              About Us
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6 font-['Playfair_Display']">
              Join Our Physical Meetings
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed font-semibold">
              Every Sunday<br />
              English Service 10:00 am to 12:00 pm<br />
              Akan Service 1:00pm to 3:00pm
            </p>
            <p className="text-base text-gray-600 mb-8 leading-relaxed">
              At Church of Pentecost UK Mansfield, we are a vibrant multicultural church community dedicated to serving God and humanity. We believe in the power of worship, fellowship, and spiritual growth. Our doors are open to everyone, regardless of background, as we grow together in Christ and serve our local community with love and compassion.
            </p>
            <div className="flex flex-wrap gap-4">
              <button className="bg-black hover:bg-gray-900 text-white px-6 py-3 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer inline-flex items-center">
                Join Now
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button className="bg-gray-200 hover:bg-gray-300 text-black px-6 py-3 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer">
                Or Online
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
